module.exports = __webpack_public_path__ + "static/media/icon-info-new.6452efa5.svg";